<template>
    <v-app>
        
        <v-main>
            <v-btn
                absolute
                top
                right
                text
                color="primary"
                outlined
                @click="closeApplication"
                class="d-none d-md-flex"
            >
                Close Application
            </v-btn>
            <v-fab-transition>
                
                <v-btn
                    fab
                    color="primary"
                    dark
                    absolute
                    top
                    right
                    small
                    class="d-flex d-sm-none"
                    style="z-index:3; position:fixed"
                    @click="closeApplication"
                >
                    <v-icon
                        small
                    >mdi-close</v-icon>
                </v-btn>
            </v-fab-transition>   

            <!-- Form Header -->
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="700"
                        flat
                    >  
                        
                        <v-img
                            :src="require('../assets/logo.png')"
                            contain
                            height="70"
                        />
                        <h1 class="primary--text  font-weight-bold">
                            {{ schoolName }}
                        </h1>
                        
                        <div class="mt-4 primary--text font-weight-bold text-h5">
                            FORM 3 - CHOICE OF SUBJECTS FORM
                        </div>
                        
                    </v-card>
                    
                </v-col>
            </v-row>

            <v-row class="">
                <v-col
                    align="center"
                    justify="center"
                >
                   
                    <v-card            
                        width="550"
                        class="mt-10"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            STUDENT INFORMATION
                        </v-card-title>
                        
                    </v-card>
                </v-col>
            </v-row>

            <v-row
                align="center"
                justify="center"
            >
                <v-card
                    class="pa-6 mt-5" 
                    width="550"
                >
                    <v-row 
                        align="center"
                        justify="center"
                        v-for="(field, index) in fields"
                        :key="index"
                    >
                        <v-col
                            cols="12"                       
                        >
                            <date-picker
                                v-if="field.type == 'date'"
                                v-bind:label="field.label"
                                v-bind:date="recordApplication[field.model]"
                                v-on:change-date="updateDate"
                                v-bind:saveStatus="field.saveStatus"
                            ></date-picker>

                            <v-text-field
                                v-else
                                v-bind:label="field.label"
                                v-model="recordApplication[field.model]"
                                @blur="validate(field, 'application')"
                                :prepend-icon="field.icon"                            
                                autocomplete="none"
                                :counter="field.counter"
                                :maxlength="field.maxlength" 
                                :disabled="field.disabled"
                                :filled="field.filled"
                                :ref="field.ref"
                                hide-details       
                            >
                                <template v-slot:append>
                                    <v-fade-transition>
                                        <v-progress-circular
                                            v-if="field.saveStatus.saving"
                                            size="16"
                                            width="3"
                                            color="info"
                                            indeterminate
                                        ></v-progress-circular>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveSuccess"
                                            small
                                            color="info"                                        
                                        >
                                            mdi-check-all
                                        </v-icon>
                                    </v-fade-transition>

                                    <v-fade-transition>    
                                        <v-icon
                                            v-if="field.saveStatus.saveError"
                                            small
                                            color="red"                                        
                                        >
                                            mdi-alert-circle
                                        </v-icon>
                                    </v-fade-transition>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>     
                </v-card>
            </v-row>

            <!-- Choice of Subjects -->
            <v-row class="mt-4">
                <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-card-title class="secondary--text pl-4 primary">
                            <div>CHOICE OF CSEC SUBJECTS</div> 
                            
                        </v-card-title>
                        <v-card-text>
                            <v-alert
                                border="left"
                                colored-border
                                type="info"
                                class="mt-4 text-justify"
                                color="primary"
                                text
                                outlined
                            >
                                Choose <strong>Five</strong> subjects from the groups below.
                                Only <strong>One</strong> Subject can be chosen from EACH group.
                                There is a first choice, second choice and third choice. Please select subjects for ALL 3 choices.
                            </v-alert>

                        </v-card-text>

                        <v-card-text>
                            <!-- 1st Choice -->
                            <v-alert
                                text
                                color="primary"
                                dense
                                border="left"
                                colored-border
                            >
                                1st Choice
                            </v-alert>

                            <v-data-table
                                :headers="headersSubjectChoice1"
                                :items="subjectChoices1"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>
                                            {{ item.line }}
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectsChoice1[item.line]"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="item.subjects"
                                                item-text="subject_title"
                                                item-value="subject_title"
                                                @change="updateSubjectChoice(1, item)"                                                 
                                            >
                                                <template v-slot:append-outer>
                                                    <v-fade-transition>
                                                        <v-progress-circular
                                                            v-if="item.saveStatus.saving"
                                                            size="16"
                                                            width="3"
                                                            color="info"
                                                            indeterminate
                                                        ></v-progress-circular>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveSuccess"
                                                            small
                                                            color="info"                                        
                                                        >
                                                            mdi-check-all
                                                        </v-icon>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveError"
                                                            small
                                                            color="red"                                        
                                                        >
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </v-fade-transition>
                                                </template>
                                            </v-select>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>

                            <!-- 2nd Choice -->
                            <v-alert
                                text
                                color="primary"
                                dense
                                border="left"
                                colored-border
                                class="mt-4"
                            >
                                2nd Choice
                            </v-alert>

                            <v-data-table
                                :headers="headersSubjectChoice2"
                                :items="subjectChoices2"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>
                                            {{ item.line }}
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectsChoice2[item.line]"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="item.subjects" 
                                                item-text="subject_title"
                                                item-value="subject_title"
                                                @change="updateSubjectChoice(2, item)"                                              
                                            >
                                                <template v-slot:append-outer>
                                                    <v-fade-transition>
                                                        <v-progress-circular
                                                            v-if="item.saveStatus.saving"
                                                            size="16"
                                                            width="3"
                                                            color="info"
                                                            indeterminate
                                                        ></v-progress-circular>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveSuccess"
                                                            small
                                                            color="info"                                        
                                                        >
                                                            mdi-check-all
                                                        </v-icon>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveError"
                                                            small
                                                            color="red"                                        
                                                        >
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </v-fade-transition>
                                                </template>
                                            </v-select>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                            
                            <!-- 3rd Choice -->
                            <v-alert
                                text
                                color="primary"
                                dense
                                border="left"
                                colored-border
                                class="mt-4"
                            >
                                3rd Choice
                            </v-alert>

                            <v-data-table
                                :headers="headersSubjectChoice3"
                                :items="subjectChoices3"
                                hide-default-footer
                                hide-default-header
                            >
                                <template v-slot:item="{ item }">
                                    <tr>
                                        <td>
                                            {{ item.line }}
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectsChoice3[item.line]"
                                                outlined
                                                dense
                                                hide-details
                                                placeholder="Subject"
                                                :items="item.subjects" 
                                                item-text="subject_title"
                                                item-value="subject_title"
                                                @change="updateSubjectChoice(3, item)"                                              
                                            >
                                                <template v-slot:append-outer>
                                                    <v-fade-transition>
                                                        <v-progress-circular
                                                            v-if="item.saveStatus.saving"
                                                            size="16"
                                                            width="3"
                                                            color="info"
                                                            indeterminate
                                                        ></v-progress-circular>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveSuccess"
                                                            small
                                                            color="info"                                        
                                                        >
                                                            mdi-check-all
                                                        </v-icon>
                                                    </v-fade-transition>

                                                    <v-fade-transition>    
                                                        <v-icon
                                                            v-if="item.saveStatus.saveError"
                                                            small
                                                            color="red"                                        
                                                        >
                                                            mdi-alert-circle
                                                        </v-icon>
                                                    </v-fade-transition>
                                                </template>
                                            </v-select>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card-text>
                        
                    </v-card>
                </v-col>
            </v-row>

            <!-- Generate Choice of Subjects Form -->
            <v-row class="mt-4">
                 <v-col
                    align="center"
                    justify="center"
                >
                    <v-card            
                        width="550"
                    >  
                        <v-btn
                            block
                            color="primary"
                            @click="displayApplicationForm"
                        >
                            Generate Choice of Subjects Form
                        </v-btn>
                    </v-card>
                </v-col>
            </v-row>       
        </v-main>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>

        <v-dialog
            v-model="dialogReport"                      
            persistent
        >
           <v-card height="80vh">
            <iframe ref="pdf" style="width:100%; height:100%" frameBorder="0" :src="src"></iframe>
           </v-card>

            <v-container
                fluid
                class="pa-0"
            >
                <v-sheet>
                    <v-row
                        justify="end"
                        class="ma-0"
                    >

                        <v-btn
                            color="primary"
                            dark
                            @click="closeRegistrationForm"
                            class="my-2 mr-4"
                        >
                            Close
                        </v-btn>

                    </v-row>
                </v-sheet>
            </v-container>

        </v-dialog>
    </v-app>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import DatePicker from '../components/DatePicker.vue';
export default {
    created: function () {
        this.initialize();
    },

    components: {
        DatePicker,
    },

    data: function () {
        return {
            fields: [
                {
                    label: 'First Name', 
                    model: 'first_name', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'firstName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Last Name', 
                    model: 'last_name', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'lastName',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },                    
                    record: 'application',
                },
                
                {
                    label: 'Birth Certificate Pin', 
                    model: 'birth_certificate_pin', 
                    type: 'text', 
                    disabled: true,
                    filled: true,
                    required: false,
                    ref: 'birthCertificatePin',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                
                {
                    label: 'Career Choice 1', 
                    model: 'career_choice_1', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'careerChoice',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
                {
                    label: 'Career Choice 2', 
                    model: 'career_choice_2', 
                    type: 'text', 
                    disabled: false,
                    filled: false,
                    required: false,
                    ref: 'careerChoice',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                    record: 'application',
                },
               
            ],
            recordApplication: {},
            subjects: [
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                { 
                    id: '', 
                    grade: '', 
                    profiles: '',
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    },  
                },
                
               
            ],
            csecSubjects: [],
            headersSubjectChoice1: [
                {text: ''},               
                {text: 'OPTION 1'},               
            ],
            headersSubjectChoice2: [
                {text: ''}, 
                {text: 'OPTION 2'},               
            ],
            headersSubjectChoice3: [
                {text: ''}, 
                {text: 'OPTION 3'},               
            ],

            subjectChoices1:[
                {
                    line: 1, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },             
                {
                    line: 2, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },          
                {
                    line: 3, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 4, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 5, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
            ],
            subjectChoices2:[
                {
                    line: 1, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },             
                {
                    line: 2, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },          
                {
                    line: 3, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 4, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 5, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
            ],
            subjectChoices3:[
                {
                    line: 1, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },             
                {
                    line: 2, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },          
                {
                    line: 3, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 4, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
                {
                    line: 5, 
                    subjects: [],
                    saveStatus: {
                        saving: false,
                        saveSuccess: false,
                        saveError: false,
                    }, 
                },            
            ],
            
            overlay: false,

            studentSubjectsChoice1:{},

            studentSubjectsChoice2:{},

            studentSubjectsChoice3:{},

            src: '',

            dialogReport: false,

        }
    },

    computed: {
        ...mapGetters({
            application: 'application/getApplication',
            applicationGrade: 'application/getApplicationGrade',
            schoolName: 'auth/getSchoolName', 
            user: 'auth/getUser',
        }),

        regex(){
            return new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) 
        },
        
    },

    methods: {
        async initialize () {
            this.overlay = true;
            const user = JSON.parse(this.user);
            try {
                const { data } = await this.getApplication(user.id);

                this.recordApplication = {
                    first_name: user.first_name,
                    last_name: user.last_name,
                    birth_certificate_pin: user.birth_certificate_pin,
                    gender: user.gender,
                    date_of_birth: user.date_of_birth,
                    career_choice_1: data.career_choice_1,
                    career_choice_2: data.career_choice_2,
                    student_id: user.id,
                }
                this.setApplication(this.recordApplication);

                const[
                    { data: dataSubjectLines},
                    { data: dataSubjectChoices },
                ] = await Promise.all([
                    this.getSubjectLines(),
                    this.getApplicationSubjectChoices()
                ])
                
                this.mapSubjectLines(dataSubjectLines);
                this.mapSubjectChoices(dataSubjectChoices);
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }
            this.overlay = false;
        },

        ...mapMutations({
            setApplication: 'application/setApplication',
            setApplicationSubjectChoice: 'application/setApplicationSubjectChoice',
            setApplicationGrade: 'application/setApplicationGrade',
            setApplicationYear: 'application/setApplicationYear',
        }),

        ...mapActions({
            postApplication: 'application/postApplication',
            postApplicationSubjectChoice: 'application/postApplicationSubjectChoice',
            getSubjectLines: 'application/getSubjectLines',
            getApplicationSubjectChoices: 'application/getApplicationSubjectChoices',
            getApplicationsLockStatus: 'application/getApplicationsLockStatus',
            getCurrentApplicationPeriod: 'application/getCurrentApplicationPeriod',
            getApplication: 'application/getApplication',
        }),

        mapSubjectLines (data) {
            this.subjectChoices1.forEach(choice => {
                switch (choice.line){
                    case 1:
                        choice.subjects = [...data[1]];
                        break;
                    case 2:
                        choice.subjects = [...data[2]];
                        break;
                    case 3:
                        choice.subjects = [...data[3]];
                        break;
                    case 4:
                        choice.subjects = [...data[4]];
                        break;
                    case 5:
                        choice.subjects = [...data[5]];
                        break;
                }
            });

            this.subjectChoices2.forEach(choice => {
                switch (choice.line){
                    case 1:
                        choice.subjects = [...data[1]];
                        break;
                    case 2:
                        choice.subjects = [...data[2]];
                        break;
                    case 3:
                        choice.subjects = [...data[3]];
                        break;
                    case 4:
                        choice.subjects = [...data[4]];
                        break;
                    case 5:
                        choice.subjects = [...data[5]];
                        break;
                }
            });

            this.subjectChoices3.forEach(choice => {
                switch (choice.line){
                    case 1:
                        choice.subjects = [...data[1]];
                        break;
                    case 2:
                        choice.subjects = [...data[2]];
                        break;
                    case 3:
                        choice.subjects = [...data[3]];
                        break;
                    case 4:
                        choice.subjects = [...data[4]];
                        break;
                    case 5:
                        choice.subjects = [...data[5]];
                        break;
                }
            });
        },

        mapSubjectChoices (data) {
            data.forEach(value => {
                if(value.choice == 1){
                    this.studentSubjectsChoice1[value.line] = value.subject_title;
                }
                else if(value.choice == 2){
                    this.studentSubjectsChoice2[value.line] = value.subject_title;
                }
                else if(value.choice == 3){
                    this.studentSubjectsChoice3[value.line] = value.subject_title;
                }
                else if(value.choice == 4){
                    this.subjectsChoice4[value.line] = value.subject_title;
                }
                else if(value.choice == 5){
                    this.subjectsChoice5[value.line] = value.subject_title;
                }
            })
        },

        validate (field) {
            // console.log(field)
            if(this.recordApplication[field.model]){
                this.updateApplication(field)
            }
        },

        async updateApplication (field) {
            this.setSaveStatus(field);
            try {
                this.setApplication(this.recordApplication);
                console.log('applicaiton: ', this.recordApplication);
                const response = await this.postApplication();
                console.log(response);
                this.setSaveStatus(field, 'saveSuccess');
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSaveStatus(field, 'saveError');  
            }
        },

        updateSubjectChoice (choice, field) {
            this.setSaveStatusSubjectChoice (choice, field.line, 'saving');
            let subjectChoice = {};

            if(choice == 1 && this.studentSubjectsChoice1[field.line]){
                subjectChoice = {
                    student_id: this.recordApplication.student_id,
                    subject_title: this.studentSubjectsChoice1[field.line],
                    line: field.line,
                    choice: 1
                }

                this.subjectChoices2.forEach( element => {
                    if(element.line == field.line){
                        element.subjects.forEach(subject => {
                            if(subject.subject_title == this.studentSubjectsChoice1[field.line]){
                                subject.disabled = true;
                            }
                        })

                    } 
                })

                console.log('subject choice 2: ', this.subjectChoices2);
            }

            if(choice == 2 && this.studentSubjectsChoice2[field.line]) {
                 subjectChoice = {
                    student_id: this.recordApplication.student_id,
                    subject_title: this.studentSubjectsChoice2[field.line],
                    line: field.line,
                    choice: 2
                }
            }

            if(choice == 3 && this.studentSubjectsChoice3[field.line]) {
                 subjectChoice = {
                    student_id: this.recordApplication.student_id,
                    subject_title: this.studentSubjectsChoice3[field.line],
                    line: field.line,
                    choice: 3
                }
            }

            this.setApplicationSubjectChoice(subjectChoice);
            this.saveSubjectChoice(choice, field.line,);
        },

        mapApplicationLock ({ locked }) {
            console.log(locked);
            if(locked){
                this.fields.forEach(f => {
                    f.disabled = true;
                });
                this.subjects.forEach(s => {
                    s.disabled = true;
                });
                this.subjectChoices1.forEach(c => {
                    c.disabled = true;
                })
                this.subjectChoices2.forEach(c => {
                    c.disabled = true;
                })
                this.documents.forEach(d => {
                    d.disabled = true;
                })
            }
        },

        async saveSubjectChoice (choice, line,) {
            try {
                const response = await this.postApplicationSubjectChoice();
                console.log(response);
                this.setSaveStatusSubjectChoice (choice, line, 'saveSuccess');
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
                this.setSaveStatusSubjectChoice (choice, line, 'saveError');
            }
        },

        updateDate (date) {
            console.log(date);
            this.recordApplication.date_of_birth = date;
            let dateOfBirthField = this.fields.filter(field => field.model == 'date_of_birth')[0]
            this.update('application', dateOfBirthField);
        },


        setSaveStatus (field, status = 'saving') {
            console.log(field);
            this.fields.forEach(value => {
                if(value.model == field.model){
                    Object.keys(field.saveStatus).forEach(key => {
                        if(key == status) field.saveStatus[key] = true;
                        else field.saveStatus[key] = false;
                    })
                }
            })
            console.log(status);
        },

        setSaveStatusSubjectChoice (choice, line, status) {
            console.log('save subject choice');
            if(choice == 1){
                this.subjectChoices1.forEach(value => {
                    if(value.line == line){
                        Object.keys(value.saveStatus).forEach(key => {
                            value.saveStatus[key] = false;
                            if(key == status){
                                value.saveStatus[key] = true;
                            }
                        })
                    }
                })
            }
            else if(choice == 2){
                this.subjectChoices2.forEach(value => {
                    if(value.line == line){
                        Object.keys(value.saveStatus).forEach(key => {
                            value.saveStatus[key] = false;
                            if(key == status){
                                value.saveStatus[key] = true;
                            }
                        })
                    }
                })
            }
            else if(choice == 3){
                this.subjectChoices3.forEach(value => {
                    if(value.line == line){
                        Object.keys(value.saveStatus).forEach(key => {
                            value.saveStatus[key] = false;
                            if(key == status){
                                value.saveStatus[key] = true;
                            }
                        })
                    }
                })
            }
        },

        setSaveStatusSubjectGrade (index, status) {
            Object.keys(this.subjects[index].saveStatus).forEach(key => {
                this.subjects[index].saveStatus[key] = false;
                if(key == status){
                    this.subjects[index].saveStatus[key] = true;
                }
            })
        },

        displayApplicationForm () {
            this.src = process.env.VUE_APP_API_URI + "/api/sixth-form-application-form/" + 
            this.recordApplication.application_id + "/" +
            this.recordApplication.year;
            this.dialogReport = true;
        },

        closeRegistrationForm () {
            console.log('close registration form');
            this.dialogReport = false;
            this.overlay = false;
            this.src = '';
        },

        closeApplication () {
            sessionStorage.clear();
            this.$router.replace('/');
        }
    }
   
}
</script>

<style scoped>
    ::v-deep .theme--light.v-btn.v-btn--outlined.v-btn--text{
        position: fixed;
        z-index: 2;
    }

    ::v-deep .v-btn--fab.v-size--small.v-btn--absolute.v-btn--top {
        top: 25px;
    }
</style>
